/**
 * Created by ewald.stamp on 18.08.2014.
 */

angular.module('cfn').service('TermsAcceptanceService', TermsAcceptanceService);

TermsAcceptanceService.$inject = [
  '$rootScope',
  '$dialog',
  '$window',
  '$location',
  '$log',
  'i18nFilter',
  'TermAcceptanceHttpProxy'
];
function TermsAcceptanceService(
  $rootScope,
  $dialog,
  $window,
  $location,
  $log,
  i18nFilter,
  TermAcceptanceHttpProxy
) {
  'use strict';

  // save myself
  var self = this;

  /**
   *
   * @param {boolean} [permissionToBeContacted = false]
   * @return {HttpPromise}
   */
  this.accept = function(permissionToBeContacted) {
    //// Default Value
    permissionToBeContacted = angular.isUndefined(permissionToBeContacted)
      ? false
      : permissionToBeContacted;

    //// Code Contract: must be Boolean
    if (permissionToBeContacted.constructor !== Boolean) {
      throw new Error('Wrong Argument');
    }

    //// run
    return TermAcceptanceHttpProxy.accept(permissionToBeContacted);
  };

  this.check = function() {
    //// Preconditions:
    // check if we are in 'terms_acceptance.html'
    // or 'terms_acceptance_invited.html'
    // then we don't to do anything
    // also ignore login.html, forgotPwd.html
    if (
      $location.absUrl().match(/terms_acceptance\.html/gi) ||
      $location.absUrl().match(/terms_acceptance_invited\.html/gi) ||
      $location.absUrl().match(/login\.html/gi) ||
      $location.absUrl().match(/forgotPwd\.html/gi)
    ) {
      return;
    }
    // user must be logged in
    if (!app.credentials.loggedIn) {
      return;
    }
    // company must be set (should be always)
    if (!app.credentials.company) {
      return;
    }
    // end preconditions

    TermAcceptanceHttpProxy.check().then(function(result) {
      // success
      switch (result.data.status) {
        case 'ok':
          return;
        case 'shouldAgree':
          self.showDialog();
          break;
        case 'mustAgree':
          // redirect
          $window.location.href = 'terms_acceptance.html';
          break;
        case 'mainUserMustAgree':
          // redirect
          $window.location.href = 'terms_acceptance_invited.html';
          break;
      }
    });
  };

  this.showDialog = function() {
    var titleText = i18nFilter('fe.terms.acceptance.title');
    var preText = i18nFilter(
      'fe.terms.acceptance.pre',
      '',
      app.credentials.person.combinedName
    );
    var changesText = i18nFilter('fe.terms.acceptance.changes');
    var postText = i18nFilter('fe.terms.acceptance.post');
    var acceptText = i18nFilter('fe.terms.acceptance.accept');
    var laterText = i18nFilter('fe.terms.acceptance.later');

    var acceptResult = 'accept';

    $rootScope.styles.bodyBlur = true;

    var dialogModel = {
      title: titleText,
      pre: preText,
      changes: changesText,
      post: postText,
      buttons: [
        { label: laterText },
        { result: acceptResult, label: acceptText }
      ],
      termAccepted: false,
      locale: app.credentials.locale,
      permissionToBeContacted: false
    };

    $dialog
      .dialog({
        templateUrl: require('./termsAcceptanceDialog.html'),
        controller: 'TermsAcceptanceMessageBoxController',
        resolve: {
          model: function() {
            return dialogModel;
          }
        }
      })
      .open()
      .then(function(result) {
        console.error(result);
        $rootScope.styles.bodyBlur = false;

        if (result === acceptResult) {
          TermAcceptanceHttpProxy.accept(dialogModel.permissionToBeContacted);
        }
      });
  };
}

angular
  .module('cfn')
  .controller(
    'TermsAcceptanceMessageBoxController',
    TermsAcceptanceMessageBoxController
  );

TermsAcceptanceMessageBoxController.$inject = ['$scope', 'dialog', 'model'];
function TermsAcceptanceMessageBoxController($scope, dialog, model) {
  $scope.title = model.title;
  $scope.pre = model.pre;
  $scope.changes = model.changes;
  $scope.post = model.post;
  $scope.buttons = model.buttons;
  $scope.model = model;
  $scope.close = function(res) {
    dialog.close(res);
  };
}
